const paths = {
  listBulkInserts: '/bulks'
};

export default paths;
